export const startSurvicate = (email, name, organization, key, tracking) => {
  console.log('Check if survicate is initialize');
  const traits = {
    name: name,
  };
  if (tracking) {
    traits.email = email;
    traits.organization = organization;
  }
  console.log('Initialize Survicate');
  // identify session
  (function (opts) {
    opts.traits = traits;
    console.log(opts.traits);
  })((window._sva = window._sva || {}));

  (function (_w) {
    const s = document.createElement('script');
    s.src = 'https://survey.survicate.com/workspaces/' + key + '/web_surveys.js';
    s.async = true;
    const e = document.getElementsByTagName('script')[0];
    e.parentNode.insertBefore(s, e);
    console.log(s);
  })(window);
};
